// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prod-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 640px !important;
  max-width: calc(100vw - 24px);
}

.prod-drawer .ant-drawer-header {
  display: none;
}

.prod-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.prod-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.prod-drawer__header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
}

.prod-drawer__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.3;
  color: #0f172a;
}

.prod-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748b;
}

.prod-drawer__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
}

.prod-drawer__close:hover {
  background: #f8fafc;
  color: #0f172a;
}

.prod-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
}

.prod-drawer__placeholder {
  min-height: 240px;
}

.prod-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  background: #ffffff;
}

.prod-drawer__note {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 11px;
  color: #94a3b8;
}

.prod-drawer__note .lucide {
  flex-shrink: 0;
}

.prod-drawer__req {
  color: #f43f5e;
  font-weight: 700;
}

.prod-drawer__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.prod-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  border-radius: 8px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.prod-drawer__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.prod-drawer__btn--ghost {
  padding: 0 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  font-weight: 600;
}

.prod-drawer__btn--ghost:hover:not(:disabled) {
  background: #f8fafc;
}

.prod-drawer__btn--primary {
  padding: 0 20px;
  border: 1px solid #0ea5e9;
  background: #0ea5e9;
  color: #ffffff;
  font-weight: 600;
}

.prod-drawer__btn--primary:hover:not(:disabled) {
  background: #0284c7;
  border-color: #0284c7;
}

@media (max-width: 640px) {
  .prod-drawer__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .prod-drawer__actions,
  .prod-drawer__btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/Products/components/ProductDrawer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".prod-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 640px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.prod-drawer .ant-drawer-header {\n  display: none;\n}\n\n.prod-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.prod-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.prod-drawer__header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #f1f5f9;\n  background: #ffffff;\n}\n\n.prod-drawer__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n  color: #0f172a;\n}\n\n.prod-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.prod-drawer__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.prod-drawer__close:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.prod-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.prod-drawer__placeholder {\n  min-height: 240px;\n}\n\n.prod-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #f1f5f9;\n  background: #ffffff;\n}\n\n.prod-drawer__note {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.prod-drawer__note .lucide {\n  flex-shrink: 0;\n}\n\n.prod-drawer__req {\n  color: #f43f5e;\n  font-weight: 700;\n}\n\n.prod-drawer__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.prod-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.prod-drawer__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.prod-drawer__btn--ghost {\n  padding: 0 16px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  font-weight: 600;\n}\n\n.prod-drawer__btn--ghost:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.prod-drawer__btn--primary {\n  padding: 0 20px;\n  border: 1px solid #0ea5e9;\n  background: #0ea5e9;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.prod-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284c7;\n  border-color: #0284c7;\n}\n\n@media (max-width: 640px) {\n  .prod-drawer__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .prod-drawer__actions,\n  .prod-drawer__btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
